import clsx from "clsx";
import "./ChangeProfileModal.scss";
import { BaseModal, Button, ModalsHeader } from "@/components";
import { ChangeProfileModalContent } from "@/components/ui/ChangeProfileModal/ChangeProfileModalContent";

type ChangeProfileModalProps = {
  open: boolean;
  overrideClassNames?: string;
  setOpen: (open: boolean) => void;
  children: React.ReactNode;
  OnPressConfirm: () => void;
  disabledConfirm?: boolean;
  showHeader?: boolean;
  showFooter?: boolean;
};

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use the new modal system instead.
 */
const ChangeProfileModal = ({
  open,
  overrideClassNames,
  showFooter = true,
  showHeader = true,
  OnPressConfirm,
  disabledConfirm,
  setOpen,
  children,
}: ChangeProfileModalProps) => {
  return (
    <BaseModal
      open={open}
      setOpen={setOpen}
      overrideClassNames={clsx("ui-consent-modal-override", overrideClassNames)}
    >
      {showHeader && (
        <ModalsHeader
          title={"Cambia profilo"}
          closeButton={"Annulla"}
          onCloseClick={() => setOpen(false)}
        />
      )}
      {children}
      {showFooter && (
        <footer className="ui-consent-modal-footer bg-white shadow">
          <div className="base-row gap-x16 flex-wrap justify-content-center">
            <Button disabled={disabledConfirm} onClick={OnPressConfirm}>
              Conferma
            </Button>
          </div>
        </footer>
      )}
    </BaseModal>
  );
};

ChangeProfileModal.Content = ChangeProfileModalContent;

export { ChangeProfileModal };
